import {
  ArchiveRestore,
  CreditCard,
  House,
  KeyRound,
  LayoutGrid,
  LifeBuoy,
  MessagesSquare,
  Settings,
  TicketPercent,
  UserPlus,
  type LucideIcon,
} from 'lucide-react'
import type { Section } from '@manaro/contracts'

export type NavCounter = 'liveWaiting' | 'salonReminders'

export interface NavItem {
  to: string
  label: string
  /** Fits under an icon in the phone's bottom bar. */
  shortLabel?: string
  icon: LucideIcon
  section: Section
  end?: boolean
  soon?: boolean
  counter?: NavCounter
}

export const navigation: NavItem[] = [
  { to: '/', label: 'Обзор', icon: LayoutGrid, section: 'overview', end: true },
  { to: '/updates', label: 'Обновления', icon: ArchiveRestore, section: 'updates' },
  { to: '/support', label: 'Поддержка', icon: LifeBuoy, section: 'support', end: true },
  { to: '/support/live', label: 'Чат на сайте', shortLabel: 'Чат', icon: MessagesSquare, section: 'support-live', counter: 'liveWaiting' },
  { to: '/salons', label: 'Салоны', icon: House, section: 'salons', counter: 'salonReminders' },
  { to: '/referrals', label: 'Рефералы', icon: UserPlus, section: 'referrals' },
  { to: '/promo-codes', label: 'Промокоды', icon: TicketPercent, section: 'promo-codes' },
  { to: '/staff', label: 'Сотрудники', icon: KeyRound, section: 'staff' },
  { to: '/subscriptions', label: 'Подписки', icon: CreditCard, section: 'overview', soon: true },
  { to: '/settings', label: 'Настройки', icon: Settings, section: 'staff', soon: true },
]

export const navigationFor = (sections: readonly Section[]): NavItem[] =>
  navigation.filter((item) => sections.includes(item.section))

/** Owners start from the numbers, support from the conversations waiting for them. */
const HOME_PRIORITY: readonly Section[] = [
  'overview',
  'support-live',
  'support',
  'salons',
  'updates',
  'referrals',
  'promo-codes',
  'staff',
]

/** Where to land after sign-in or when a section is closed. */
export function homePath(sections: readonly Section[]): string {
  const section = HOME_PRIORITY.find((candidate) => sections.includes(candidate))
  return navigation.find((item) => !item.soon && item.section === section)?.to ?? '/login'
}

/** Phones get a bottom bar like an app: the four most used sections, everything else behind «Ещё». */
const TAB_PRIORITY: readonly Section[] = [
  'support-live',
  'support',
  'salons',
  'overview',
  'updates',
  'referrals',
  'promo-codes',
  'staff',
]
const MAX_TABS = 4

export function mobileTabs(sections: readonly Section[]): { tabs: NavItem[]; more: NavItem[] } {
  const available = navigation.filter((item) => !item.soon && sections.includes(item.section))
  const ranked = [...available].sort(
    (a, b) => TAB_PRIORITY.indexOf(a.section) - TAB_PRIORITY.indexOf(b.section),
  )
  const tabs = ranked.slice(0, MAX_TABS)
  return { tabs, more: available.filter((item) => !tabs.includes(item)) }
}
